import styled from 'styled-components';
import React from 'react';
import { motion } from 'framer-motion';
import image from '../../../images/mockup-home-screen.png';

const Section = styled.section`
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 0 4rem;

  @media screen and (max-width: 900px) {
    width: 100%;
    padding: 2.5rem 1.5rem 4rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.85fr;
  align-items: center;
  gap: 4rem;

  @media screen and (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 3rem;
    text-align: center;
  }
`;

const TextColumn = styled.div``;

const Problem = styled.p`
  font-family: var(--font-body);
  font-size: clamp(1.05rem, 1.6vw, 1.25rem);
  color: var(--color-ink-soft);
  margin-bottom: 1rem;

  @media screen and (max-width: 768px) {
    text-align: start;
    font-size: 0.8rem;
    margin-top: 30px;
  }
`;

const Title = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(2rem, 4vw, 2.9rem);
  font-weight: 700;
  line-height: 1.12;
  color: var(--color-ink);
  letter-spacing: -0.01em;
  margin-bottom: 1.5rem;

  span {
    color: var(--color-accent-hover);
  }

  @media screen and (max-width: 900px) {
    text-align: start;
  }
`;

const Resolution = styled.p`
  font-family: var(--font-body);
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--color-ink-soft);
  max-width: 460px;

  @media screen and (max-width: 900px) {
    max-width: none;
    margin: 0 auto;
    text-align: start;
  }
`;

const ImageColumn = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 900px) {
    order: -1;
  }
`;

const FrameWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 340px;

  /* Técnica de proporção fixa via padding-top (funciona em qualquer navegador,
     diferente de "aspect-ratio", que ainda não tem suporte universal). */
  &::before {
    content: '';
    display: block;
    padding-top: 133.33%; /* proporção 3:4 */
  }

  @media screen and (max-width: 900px) {
    max-width: 260px;
  }
`;

const Backdrop = styled.div`
  width: 78%;
  position: absolute;
  top: 8%;
  right: 6%;
  bottom: 8%;
  left: 16%;
  background: linear-gradient(155deg, var(--color-brand) 0%, var(--color-brand-deep) 100%);
  border-radius: var(--radius-lg);
  z-index: 0;
`;

const PhotoFrame = styled(motion.div)`
  position: absolute;
  top: 0;
  right: 16%;
  bottom: 0;
  left: 0;
  z-index: 1;
  border-radius: var(--radius-lg);
  // overflow: hidden;
  // box-shadow: var(--shadow-strong);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: top center;
  }
`;

// Evita que a captura estática do react-snap (Fase 5) grave estilos de
// animação "assentados" que depois conflitam com a primeira renderização do
// cliente na hidratação (React #418/#425) — ver mesma guarda em PainList.jsx.
const isPrerendering = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

const fadeUp = isPrerendering ? {} : {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.5 },
  transition: { duration: 0.3, ease: 'easeOut' },
};

const photoMotionProps = isPrerendering ? {} : {
  initial: { opacity: 0, y: 30, rotate: -8 },
  whileInView: { opacity: 1, y: 0, rotate: -8 },
  viewport: { once: true, amount: 0.4 },
  transition: { duration: 0.4, ease: 'easeOut' },
};

const MobileExplain = () => {

  return (
    <Section>
      <Grid>
        <TextColumn as={motion.div} {...fadeUp}>
          <Problem>Você não pode estar em todas as mesas ao mesmo tempo.</Problem>
          <Title>O seu negócio <span style={{color: '#005586'}}>pode</span>.</Title>
          <Resolution>
            Mesas, caixa e pedidos sincronizados em tempo real — acompanhe tudo de onde estiver, mesmo longe do salão.
          </Resolution>
        </TextColumn>

        <ImageColumn>
          <FrameWrap>
            <Backdrop />
            <PhotoFrame {...photoMotionProps}>
              <img src={image} alt="Celular com o painel de vendas do SofChef aberto" />
            </PhotoFrame>
          </FrameWrap>
        </ImageColumn>
      </Grid>
    </Section>
  );
};

export default MobileExplain;
